//React
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Styles
import '../styles/Parametres.css';

// Components
import MissionHeader from '../components/MissionHeader';
import MainButton from '../components/MainButton';
import PageTransition from '../components/PageTransition';
import InputNumber from '../components/InputNumber';

// Contextes
import { useTimer } from '../contextes/useTimer';

// Page des paramètres
const Parametres: React.FC = () => {
    const { setInitialTime, setTime } = useTimer();
    const [timeValue, setTimeValue] = useState<number>(20);
    const navigate = useNavigate();
    const location = useLocation();
    const isSettingButtonClicked = location.state?.isSettingButtonClicked;
    // Fonction pour gérer le clic sur le bouton Valider
    const handleValiderClick = () => {
        setInitialTime(timeValue * 60);
        setTime(timeValue * 60);
        if (timeValue === 0) {
        }
        if (!isSettingButtonClicked) {
            navigate('../game');
        }
    };

    return (
        <PageTransition>
            <div className='parametres-container'>
                <MissionHeader
                    showBackButton={false}
                    showSettingsButton={false}
                    showCloseButton={true}
                    closeButtonVariant='tertiary'
                    showTimer={false}
                />
                <div className='parametres-timer'>
                    <img
                        src='./images/timer-icon.png'
                        alt='Icon horloge'
                    />
                    <h1 className='parametres-title'>
                        {isSettingButtonClicked ? 'Changer' : 'Définir'} le temps de jeu
                    </h1>
                    <div className='input-group'>
                        <InputNumber
                            setValue={setTimeValue}
                            tensInitialValue={2}
                            onesInitialValue={0}
                            onEnter={handleValiderClick}
                        />

                        <span>min</span>
                    </div>
                </div>
                <MainButton
                    text='Valider'
                    backgroundColor='tertiary'
                    onClick={handleValiderClick}
                    disabled={timeValue === 0}
                />
            </div>
        </PageTransition>
    );
};

export default Parametres;
